import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { CampaignDetailsPresenter } from "./presenter";
import { useCampaignDetailsQuery } from "../../model/repository/existing/query/use-campaign-details-query";

type Props = {
	hotelID: string;
	campaignID: string;
};

export const CampaignDetailsContainer = ({ hotelID, campaignID }: Props) => {
	const { data } = useCampaignDetailsQuery({ hotelID, campaignID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <CampaignDetailsPresenter hotelID={hotelID} campaignID={campaignID} serverModel={data} />;
};

CampaignDetailsContainer.displayName = "CampaignDetailsContainer";
